import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['textarea'];

  select(event) {
    this.textareaTarget.value = event.currentTarget.value;
  }
}
